import MUISwitch from "./MUISwitch"
import Stack from '@mui/material/Stack';
import { useState, useEffect } from "react";
import { Card, Box, Typography } from "@mui/material";
import Gauge from "./Gauge";
import ReactECharts from 'echarts-for-react';
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";
import '../../../../cssfiles/homepage.css';

export default function Simplegauge(props){
    //console.log("IN SwitchGauge I AM IN");
    const historicaldata = useSelector((state) => state.mainpagedata.historicaldata);

    const [energycostbudget, setEnergyCostBudget] = useState(true); //false->shows INR , True->shows kWh
    const [stateVarB, setStateVarB] = useState(true);
    const[exceed, setExceed] = useState(false);
    const[percentageConsumed, setPercentageConsumed] = useState(0);
    const[targetvalue, setTargetValue] = useState(0);
    const[totalvalue, setTotalValue] = useState(0);
    const [gaugedataoption,setGaugedataoption] = useState({})
    const [serise, setSerice] = useState([])

    const gaugecallback = (valueobtained) =>{
        setPercentageConsumed(valueobtained)
    }
    function handleChange2(event){
      setStateVarB(!stateVarB.checkedB);
    };

    useEffect(()=>{

    },[percentageConsumed])

    var minValue = -260;
    var maxValue = 260;

    useEffect(() => {
        for(let i=0; i<historicaldata.length; i++) {
            if(props.widgetprop.props.extended.tagprops[0].tagid === historicaldata[i].tagid) {
                var sum = 0
                var length_for_average = historicaldata[i].histdata.length;

                console.log("historicaldata[i].histdata ", historicaldata[i].histdata)
                for(let j=0; j<historicaldata[i].histdata.length; j++) {
                    if((historicaldata[i].histdata[j].value > maxValue) || (historicaldata[i].histdata[j].value < minValue)){
                      length_for_average = length_for_average - 1; 
                    }else{
                        sum = sum + historicaldata[i].histdata[j].value
                    }
                    //sum = sum + historicaldata[i].histdata[j].value
                    
                }
                var avg = []
                if(sum === 0) {
                  avg.push(0)
                } else {
                  avg.push((sum / length_for_average).toFixed(2))
                }
                  
                setSerice(avg)
            }
        }
    },[historicaldata])


    var options = {
        chart: {
          type: 'radialBar',
          offsetY: -20,
          sparkline: {
            enabled: true
          }
        },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: "#e7e7e7",
              strokeWidth: '97%',
              margin: 5, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: '#999',
                opacity: 1,
                blur: 2
              }
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                offsetY: -2,
                fontSize: '22px',
                color: 'var(--axis-color)',
                formatter: function (val) {
                    return val 
                  }
              }
            }
          }
        },
        grid: {
          padding: {
            top: -10
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            shadeIntensity: 0.4,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 53, 91]
          },
        },    
        labels: ['Average Results'],
      }

    return(  
        <>
            <div style={{width: '100%', height: '100%', marginTop: '40px'}}>
                <Chart options={options} series={serise} type="radialBar" height="100%" width="100%" />  
                {/*<Gauge widgetprop={props.widgetprop} energycostbudget={energycostbudget} exceed={exceed} setExceed={setExceed} gaugecallback={gaugecallback} setPercentageConsumed={setPercentageConsumed} setTargetValue={setTargetValue} setTotalValue={setTotalValue}/>*/}
            </div>
        </>
    )
}